import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueMask from 'v-mask';
import CorporationPage from './CorporationPage.vue';
import '../../../libs/vee-validate';

Vue.use(VueI18n);
Vue.use(VueMask);

new Vue({
  el: "#app",
  i18n: new VueI18n(window._i18n),
  components: {
    CorporationPage,
  },
})
